module.exports = __webpack_public_path__ + "img/close-white-icon.2feec3f9.svg";